// src/server/models/modelStore.js
export const modelStore = {
    articles: {
        label: 'Articles',
        table: 'articles',
        path: 'articles',
        alias: 'a',
        customer_id: true,
        defaultSort: { field: 'id', order: 'DESC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true, searchable: true, editable: false },

            {
                field: 'active',
                type: 'boolean',
                width: 90,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },

            { field: 'sku', type: 'string', width: 140, sortable: true, searchable: true, filter: true, editable: true },

            { field: 'label', type: 'string', flex: 2, minWidth: 180, sortable: true, searchable: true, filter: true, editable: true },

            { field: 'description', type: 'string', flex: 3, minWidth: 220, editable: true },

            { field: 'price', type: 'number', width: 120, sortable: true, filter: true },

            { field: 'stepamount', headerName: 'Per Package', type: 'integer', sortable: false, filter: true },

            { field: 'curstock', headerName: 'Stock', type: 'number', width: 110, sortable: true, filter: true, cellRenderer: "gridCurstockRenderer" },

            {
                field: 'curstocktypes',
                headerName: 'Type Stocks',
                type: 'boolean',
                width: 130,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCurstockTypesRenderer"
            },

            {
                headerName: 'Variants',
                field: 'edittypes',
                virtual: true,
                width: 110,
                valueGetter: () => 'edit',
                sortable: false,
                filter: false,
                cellRenderer: "editTypesRenderer"
            },

            {
                headerName: 'Product Group',
                field: 'editmasterarticle',
                virtual: true,
                width: 140,
                valueGetter: () => 'edit',
                sortable: false,
                filter: false,
                cellRenderer: "editArticleMasterRenderer"
            },

            {
                headerName: 'Content',
                field: 'editbricks',
                virtual: true,
                width: 110,
                valueGetter: () => 'edit',
                sortable: false,
                filter: false,
                cellRenderer: "editBricksRenderer"
            },

            { headerName: 'Weight', field: 'weight', type: 'integer', width: 80, sortable: true, filter: true },

            {
                headerName: 'Copy',
                field: 'duplicate',
                virtual: true,
                width: 110,
                valueGetter: () => 'edit',
                sortable: false,
                filter: false,
                cellRenderer: "editArticleDuplicateRenderer"
            },

            {
                headerName: 'JsonLD',
                field: 'jsonld',
                width: 110,
                sortable: false,
                filter: false,
                editable: true,
                cellEditor: 'agSelectCellEditor'
            },

            { field: 'miscinfo', type: 'string', minWidth: 80, sortable: true, searchable: true, filter: true, editable: true },

            { field: 'created_at', headerName: 'Created', type: 'date', width: 140, sortable: true },

            {
                headerName: '',
                field: 'remove',
                virtual: true,
                width: 80,
                valueGetter: () => 'edit',
                sortable: false,
                filter: false,
                cellRenderer: "removeRenderer"
            }

        ],

        dateField: 'created_at'
    },

    article_groups: {
        label: 'Groups',
        table: 'article_groups',
        path: 'article-groups',
        alias: 'ag',
        customer_id: true,
        defaultSort: { field: 'id', order: 'ASC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true },
            { field: 'label', type: 'string', flex: 2, minWidth: 200, sortable: true, filter: true },
            { field: 'labelnz', headerName: 'Internal Label', type: 'string', flex: 2, minWidth: 200, sortable: true, filter: true },
            {
                field: 'priceneutral',
                headerName: 'Price Neutral',
                type: 'boolean',
                width: 130,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },
            {
                field: 'display',
                headerName: 'Display Only',
                type: 'boolean',
                width: 130,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },
            {
                field: 'doimgsearch',
                headerName: 'Img Search',
                type: 'boolean',
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },
            {
                field: 'overlay',
                type: 'boolean',
                width: 130,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            }
        ],

        dateField: 'created_at'
    },

    article_types: {
        label: 'Types',
        table: 'article_types',
        path: 'article-types',
        alias: 'at',
        customer_id: true,
        defaultSort: { field: 'id', order: 'ASC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true },
            { field: 'label', type: 'string', flex: 2, minWidth: 200, sortable: true, filter: true },

            {
                field: 'volumebase',
                type: 'boolean',
                width: 120,
                sortable: true,
                filter: true,
                cellRenderer: "gridCheckbox"
            },

            {
                headerName: 'Group',
                field: 'edittypegroup',
                virtual: true,
                width: 140,
                valueGetter: () => 'edit',
                sortable: false,
                filter: false,
                cellRenderer: "editTypeGroupRenderer"
            }
        ],

        dateField: 'created_at'
    },

    orders: {
        label: 'Orders',
        table: 'orders',
        path: 'orders',
        alias: 'o',
        customer_id: true,
        defaultSort: { field: 'created_at', order: 'DESC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true, searchable: true },
            { field: 'order_number', headerName: 'Order Nr.', type: 'string', width: 160, sortable: true, searchable: true, filter: true },

            { field: 'status', type: 'string', width: 140, sortable: true, searchable: true, filter: true },

            { field: 'total_amount', headerName: 'Total', type: 'number', width: 130, sortable: true, searchable: true, filter: true },

            { field: 'currency', type: 'string', width: 90, sortable: true, filter: true },

            { field: 'remote_user_email', headerName: 'User Email', type: 'string', flex: 2, minWidth: 220, sortable: true, searchable: true, filter: true },

            { field: 'created_at', headerName: 'Created', type: 'date', width: 150, sortable: true },

            {
                headerName: '',
                field: 'pdf',
                virtual: true,
                width: 80,
                valueGetter: () => 'edit',
                sortable: false,
                searchable: false,
                filter: false,
                cellRenderer: "pdfRenderer"
            }


        ],

        dateField: 'created_at'
    },

    users: {
        label: 'Users',
        table: 'users',
        path: 'users',
        alias: 'u',
        customer_id: true,
        defaultSort: { field: 'id', order: 'DESC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true },
            { field: 'email', type: 'string', flex: 2, minWidth: 240, sortable: true, filter: true },

            {
                field: 'active',
                type: 'boolean',
                width: 90,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },
            {
                headerName: 'Password',
                field: 'password',
                cellEditor: 'PasswordCellEditor'
            },
            { field: 'created_at', headerName: 'Created', type: 'date', width: 150, sortable: true }
        ],

        dateField: 'created_at'
    },

    customers: {
        label: 'Customers',
        table: 'customers',
        path: 'customers',
        alias: 'c',
        customer_id: false,
        defaultSort: { field: 'id', order: 'DESC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true },
            { field: 'name', type: 'string', flex: 2, minWidth: 220, sortable: true, filter: true },
            { field: 'email', type: 'string', flex: 2, minWidth: 240, sortable: true, filter: true },

            {
                field: 'active',
                type: 'boolean',
                width: 90,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },

            { field: 'created_at', headerName: 'Created', type: 'date', width: 150, sortable: true }
        ],

        dateField: 'created_at'
    },

    api_keys: {
        label: 'API Keys',
        table: 'api_keys',
        path: 'api-keys',
        alias: 'k',
        customer_id: true,
        defaultSort: { field: 'id', order: 'DESC' },

        columns: [
            { field: 'id', type: 'number', width: 90, sortable: true },
            { field: 'apikey', type: 'string', flex: 3, minWidth: 320, sortable: true, filter: true },

            {
                field: 'active',
                type: 'boolean',
                width: 90,
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: "gridCheckbox"
            },
            { field: 'lang', headerName: 'Language', type: 'string', width: 80, sortable: true },
            { field: 'expires_at', headerName: 'Expires', type: 'date', width: 150, sortable: true },
            { field: 'created_at', headerName: 'Created', type: 'date', width: 150, sortable: true }
        ],

        dateField: 'created_at'
    }
};


export function resolveModelByPath(path) {
    const key = Object.keys(modelStore).find(
        (k) => modelStore[k].path === path
    );

    if (!key) return null;

    return {
        key,
        def: modelStore[key],
    };
}

export function getModelDefinition(name) {
    return modelStore[name] || null;
}